<template>
  <div style="padding: 20px;height: 100%">

    <el-table stripe="true" border="true"  :data="transactionListData" size="large" style="height: 80%;width: 100%;margin-top: 20px">
      <el-table-column label="id" prop="id" width="200px" align="center"/>
      <el-table-column label="说明" prop="remark" width="300px" align="center"/>
      <el-table-column label="内容" width="500px" align="center">
        <template #default="scope">
          <el-input v-model="scope.row.content" placeholder="请输入内容" style="width: 300px" allowClear="true"  clearable/>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button type="success" style="margin-left: 20px" @click="saveSetting(scope.row)" >保存</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 20px;margin-bottom:20px;justify-content: center"  background layout="prev, pager, next" :total="totalCount" v-model:current-page="currentPage" @change="showSizeChange" :page-size="12" />
  </div>

</template>
<script>
import {$http} from "@/api";
import { ElMessage } from 'element-plus'
import {ElMessageBox} from "element-plus";
import {useRouter} from "vue-router";

export default {
  name:'SettingListPage',
  data(){
    return{
      transactionListData:[],
      currentPage:1, //当前页码
      totalCount:0, //服务器返回总数量
      keyUserId:'', // 搜索用ID
      router:useRouter()
    }
  },
  mounted(){
    // if()
    this.getUserPayList()
  },
  methods:{
    // 获取列表
    getUserPayList(){
      const formData = new FormData();
      //

      $http('/get_setting_list',formData)
          .then(res=>{

            this.transactionListData = res['resource']
            this.totalCount = res['totalCount']

          })
    },
    // 页码回调
    showSizeChange(current,size){
      this.urrentPage = current
      this.getUserPayList()
    },
    // 渠道回调
    keyIsSysChange(value){
      this.channel = value
    },
    // 状态回调
    keyIsStatusChange(value)
    {
      this.status = value
    },
    // 删除订单
    saveSetting(obj){

      if(obj.content == ""){
        ElMessage({
          message: '内容不能为空',
          type: 'error',
        })
        return
      }

      let self = this;
      ElMessageBox.confirm(
          '确认保存？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
      ).then(() => {
        const formData = new FormData()
        formData.append('id',obj.id)
        formData.append("content",obj.content)

        $http('/save_setting',formData)
            .then(res=>
            {
              ElMessage({
                message: '保存成功',
                type: 'success',
              })
              self.getUserPayList()
            })
      }).catch(() => {

      })

    }
  }
}
</script>